import React from "react";
import { NavLink, useParams } from "react-router-dom";
import styled from "styled-components";
import { linksDossier } from "routes/navigation/sidebarDossierLinks"; 
import { useGetDossierByIdQuery } from "actions/dossiers/queries";
import { 
  PARTAGE_DOSSIER, 
  PRODUCTS_PATH, 
  SOLDES, 
  CLIENT, 
  VENTE, 
  FACTURATION, 
  CREANCES 
} from "routes/navigation/navigationPaths";

const COMMERCIAL_ALLOWED_PATHS = new Set([
  PRODUCTS_PATH,
  SOLDES,
  FACTURATION,
  CLIENT,
  VENTE,
  CREANCES,
]); 

const NavBarWrapper = styled.div`
  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 62px;
    background: white;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
    padding: 0 6px;
    border-top: 1px solid #ccc;
    z-index: 1000;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      height: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.25);
      border-radius: 999px;
    }
  }

  @media (min-width: 769px) {
    display: none;
  }
`;

const IconLink = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 10px;
  padding: 6px 8px;
  min-width: 70px;
  max-width: 86px;
  border-radius: 8px;
  color: #6b7280;
  flex: 0 0 auto;

  &.active {
    background-color: rgba(0, 150, 136, 0.08);
    color: #6b7280;

    &.active svg {
      color: #009688;
    }

   &.active span {
    color: #009688;
  }
    span {
      color: #6b7280;
    }
  }

  svg {
    font-size: 20px;
    color: #6b7280;
  }
         
  span {
    color: inherit;
    font-size: 10px;
    margin-top: 3px;
    color: #6b7280;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    line-height: 1;
  }
`;

const BottomNavClients = () => {
  const { clientID: dossier_id } = useParams();
  const { data: dossier } = useGetDossierByIdQuery({ id: dossier_id }, { skip: !dossier_id });
  const userRole = dossier?.user_role;

  const filteredLinks = linksDossier.filter(link => {
    if (userRole === 'COMMERCIAL') {
      return COMMERCIAL_ALLOWED_PATHS.has(link.path);
    }
    if (link.path === PARTAGE_DOSSIER) {
      return userRole === 'ADMIN';
    }
    return true;
  });

  return (
    <NavBarWrapper>
      {filteredLinks.map((item, index) => (
        <IconLink
          key={index}
          to={item.path}
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          <item.icon />
          <span>{item.label}</span>
        </IconLink>
      ))}
    </NavBarWrapper>
  );
};

export default BottomNavClients;
